import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarDays } from "lucide-react";
import { getEvents } from "@/lib/site";
import { formatEventDate } from "@/pages/MessekalenderPage";

export default function MesseBanner() {
  const [event, setEvent] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    getEvents()
      .then((events) => {
        const today = new Date(new Date().toDateString());
        const next = events.find((e) => {
          if (!e.attending) return false;
          const days = (new Date(e.date) - today) / 86400000;
          return days >= 0 && days <= 7;
        });
        setEvent(next || null);
      })
      .catch(() => {});
  }, []);

  if (!event) return null;
  const days = Math.round(
    (new Date(event.date) - new Date(new Date().toDateString())) / 86400000
  );
  const countdown = days === 0 ? "I DAG" : days === 1 ? "i morgen" : `om ${days} dage`;

  return (
    <button
      data-testid="messe-banner"
      onClick={() => navigate("/messekalender")}
      className="relative z-40 flex w-full items-center justify-center gap-3 border-b border-forest/40 bg-forest/20 px-6 py-3 text-center backdrop-blur-md transition-colors hover:bg-forest/30"
    >
      <CalendarDays className="h-4 w-4 shrink-0 text-pale" />
      <span className="font-mono text-[11px] uppercase tracking-[0.15em] text-pale">
        {event.name} {countdown} ({formatEventDate(event.date)}) — bestil nu og vælg gratis
        afhentning på messen i kassen
      </span>
    </button>
  );
}
